import { defineStore } from 'pinia';

export const useAuthProvidersStore = defineStore('authProviders', {
  state: () => ({ providers: [] }),
  actions: {
    setProviders(providers) { this.providers = providers; }
  },
  getters: {
    samlProviders:    (state) => state.providers.filter(p => p.type === 'saml'),
    databaseProvider: (state) => state.providers.find(p => p.type === 'database'),
  }
});
